import { FC, Fragment } from 'react';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { ReasonForEdits } from 'modals/ShiftModal/src/views/ReasonForEdits';
import { OrderStatusEnum } from 'types/graphql';
import { NotifyTeamMember } from 'modals/ShiftModal/src/views/NotifyTeamMember';
import { BKJButton } from '@bookjane2/bookjane-design-library';
import { useEditViewContext } from 'modals/ShiftModal/src/views/EditView/EditView.context';
import { AutoMargin } from 'components/AutoMargin';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { useShiftModalPropsContext } from 'modals/ShiftModal/ShiftModal.props.context';
import { useTranslation } from 'hooks/useTranslation';
import { useIsSentToAgencyJane } from 'hooks/useAgencyHooks/useAgencyHooks';

export const EditingReasonAndNotifyView: FC = () => {
  const { t } = useTranslation();
  const { data } = useShiftModalDataContext();
  const { status, mainJane, community, sentToAgencies } = data!.order;
  const { isSubmitting, values, isNotifyFlowRequired } = useEditViewContext();

  const { goToConfirmEditsView } = useShiftModalPropsContext();

  const isB2BMarketplaceJane = useIsSentToAgencyJane({
    mainJane,
    sentToAgencies,
    orderCommunityOrgId: community?.organization?.id,
  });

  // `acceptedByAgency` is `false` if the shift was accepted by a B2B marketplace jane
  // this is possibly a BE issue so for now we're adding `|| (sentToAgencies && isB2BMarketplaceJane)` to capture this scenario
  const acceptedByAgencyOrB2BMarketplace =
    mainJane?.acceptedByAgency || (sentToAgencies && isB2BMarketplaceJane);

  const isInProgressOrCompletedShift =
    status.value === OrderStatusEnum.in_progress || status.value === OrderStatusEnum.completed;

  const isShowNotifyFlow =
    isNotifyFlowRequired &&
    !(isInProgressOrCompletedShift && mainJane && acceptedByAgencyOrB2BMarketplace);

  const isReasonRequired =
    values?.reasonForEdit?.[0] === 'other'
      ? values?.reasonForEdit?.[0] && values?.specifiedReasonForEdit?.[0]
      : values?.reasonForEdit?.[0];

  const isDisabled = isInProgressOrCompletedShift
    ? !(
        isReasonRequired &&
        (mainJane && !acceptedByAgencyOrB2BMarketplace && isNotifyFlowRequired
          ? values.notification_method
          : true)
      )
    : !values.notification_method;

  return (
    <Fragment>
      {isInProgressOrCompletedShift && <ReasonForEdits />}
      {isShowNotifyFlow && <NotifyTeamMember />}
      <BKJSideModalFooter justifyContent="space-between">
        <AutoMargin />
        <BKJButton
          variant="PurpleSolid"
          width="180px"
          type="button"
          disabled={isDisabled}
          isLoading={isSubmitting}
          onClick={goToConfirmEditsView}
        >
          {t('auth:NEXT')}
        </BKJButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};
